import Query from '../../../components/Report';

const query = new Query('google-surfaces-performance');

export default query;
